import find from 'lodash/find'

/**
 * Get buffer by its identifier
 * @function getBufferById
 * @param {number} bufferId buffer identifier
 * @param {*} proposalInfoList list of information about proposals
 * @return {object} buffer which id is bufferId. Null when not found
 */
export function getBufferById(bufferId, proposalInfoList) {
  for (let i = 0; i < proposalInfoList.length; i++) {
    const found = find(proposalInfoList[i].buffers, buffer => buffer.bufferId === bufferId)
    if (found !== null) {
      return found
    }
  }
  return null
}

/**
 * Get a macromolecule by its indentifier from the proposal info
 * @param {number} macromoleculeId investigated macromolecule's identifier
 * @param {*} proposalInfoList list of information about proposals
 * @function getMacromoleculeById
 * @returns {object} the macromolecule which id is macromoleculeId. Null when not found.
 */
export function getMacromoleculeById(macromoleculeId, proposalInfoList) {
  for (let i = 0; i < proposalInfoList.length; i++) {
    const found = find(
      proposalInfoList[i].macromolecules,
      macromolecule => macromolecule.macromoleculeId === macromoleculeId
    )
    if (found !== null) {
      return found
    }
  }
  return null
}

/**
 * Get a macromolecule by acronym
 * @param {String} acronym searched acronym
 * @param {*} proposalInfoList list of information about proposals
 * @function getMacromoleculeByAcronym
 * @returns {object} the macromolecule which acronym is acronym. Null when not found.
 */
export function getMacromoleculeByAcronym(acronym, proposalInfoList) {
  for (let i = 0; i < proposalInfoList.length; i++) {
    const found = find(proposalInfoList[i].macromolecules, macromolecule => macromolecule.acronym === acronym)
    if (found !== null) {
      return found
    }
  }
  return null
}

/** Get the proposal identifier by proposal name */
export function getProposalIdByProposalName(proposalName, proposalInfoList) {
  for (let i = 0; i < proposalInfoList.length; i++) {
    const found = find(proposalInfoList[i].proposal, proposal => proposal.code + proposal.number === proposalName)
    if (found !== null) {
      return found.proposalId
    }
  }
  return null
}
